import jwt_decode from "jwt-decode";
import { IAuthInterface } from "@gwn/guac-lib";
import axios from "axios";

export const getSmartSessionId = (): string => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get("session_id");
};

export const getSmartLauncherToken = async (sessionId: string) => {
  const smartLauncherUrl = process.env.GUAC_SMART_LAUNCHER_URL;

  const response = await axios.post(
    smartLauncherUrl + "/launcher/token",
    {
      session_id: sessionId,
    },
    {
      withCredentials: true,
    }
  );

  return response.data.access_token;
};

export const createSmartAuthInterface = async (sessionId: string): Promise<IAuthInterface> => {
  const token = await getSmartLauncherToken(sessionId);
  const tokenParsed = jwt_decode(token) as any;

  const realmAccessRoles = tokenParsed.realm_access.roles;
  const resourceAccessRoles = tokenParsed.resource_access.account.roles;
  const userRoles = [...realmAccessRoles, ...resourceAccessRoles];

  const isUserRoleMember = (groupName: string): boolean => {
    return userRoles.includes(groupName);
  };

  const isTokenExpired = () => {
    const expiresIn = tokenParsed.exp - Math.ceil(new Date().getTime() / 1000);

    return expiresIn < 0;
  };

  return {
    logout: () => {
      window.location.href = "/";
    },
    userEmail: "",
    userRoles,
    getJwt: () => token,
    getToken: () => tokenParsed,
    isTokenExpired,
    isUserRoleMember,
  };
};
